import { NgFor } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DateSelectorConfig, DateSelectorRangeBase, DateSelectorSubRange, DateSelector_SubRangeTypeUI } from '../../daterange_utils';
import { VizFormModule } from '../form/form.module';



@Component({
    selector: 'app-date-selector-datesubrange',
    templateUrl: './datesubrange.component.html',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        FormsModule,
        NgFor,
        VizFormModule,
        MatSelectModule,
        MatInputModule,
        MatDatepickerModule,
        FontAwesomeModule,
    ],
})
export class DateSubRangeComponent implements OnInit, OnChanges {

   _common = _common;
   @Inject(LOCALE_ID) public locale: string;
   @Input() range: DateSelectorSubRange = new DateSelectorSubRange();
   @Output() change = new EventEmitter<DateSelectorSubRange>();
   @Output() remove = new EventEmitter<DateSelectorSubRange>();
   @Input() trigger: EventEmitter<DateSelectorConfig>;

   startDate: UntypedFormControl;
   endDate: UntypedFormControl;
   highlightStart = false;
   highlightEnd = false;

   types: any = DateSelector_SubRangeTypeUI.map((o) => { return { id: o, name: o }; });

   constructor() {
      this.startDate = new UntypedFormControl(new Date());
      this.endDate = new UntypedFormControl(new Date());

   }
   ngOnChanges(changes: SimpleChanges): void {
      if (changes['range']) {
         this.refresh();
      }
   }

   ngOnInit(): void {
      this.trigger.subscribe(() => {
         this.refresh();
      });
      this.refresh();
   }
   highlight(curRange: DateSelectorRangeBase, curStart: boolean) {
      this.highlightStart = false;
      this.highlightEnd = false;
      if (curRange === this.range) {
         this.highlightStart = curStart;
         this.highlightEnd = !curStart;
      }
   }


   removeRange() {
      this.remove.emit(this.range);
   }

   refresh() {
      this.startDate.setValue(this.range.start);
      this.endDate.setValue(this.range.end);
      this.updateUI();

   }

   updateUI() {
      if (this.range.hasEndDate())
         this.endDate.enable();
      else
         this.endDate.disable();

      if (this.range.hasStartDate())
         this.startDate.enable();
      else
         this.startDate.disable();
   }

   onChange() {
      this.range.start = this.startDate.value;
      this.range.end = this.endDate.value;

      this.updateUI();
      this.change.emit(this.range);

   }

}
